import React from 'react';

/**
 * Grosse tuile pictogramme du socle — pour les gestes qu'un agent doit pouvoir
 * faire sans lire : le pictogramme et la couleur portent le sens, le libellé ne
 * fait que le confirmer.
 *
 * Mêmes garanties que `Button` : zone tactile bien au-delà des 44 px, et
 * `libelle` obligatoire (texte visible ET nom accessible).
 */
type Teinte = 'ambre' | 'ciel';

const TEINTES: Record<Teinte, string> = {
    // Teintes sémantiques (panne / objet), les mêmes qu'au web.
    ambre: 'border-amber-300 bg-amber-50 text-amber-900',
    ciel: 'border-sky-300 bg-sky-50 text-sky-900',
};

interface TuileProps {
    libelle: string;
    icone: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    teinte: Teinte;
    onPress: () => void;
    disabled?: boolean;
}

export default function Tuile({ libelle, icone: Icone, teinte, onPress, disabled = false }: TuileProps) {
    return (
        // mobile-check-ignore — composant du socle, comme Button.
        <button
            type="button"
            onClick={onPress}
            disabled={disabled}
            className={[
                'flex min-h-[6rem] w-full flex-col items-center justify-center gap-2 rounded-2xl border-2 px-3 py-4',
                'text-base font-semibold disabled:opacity-50 active:scale-[0.98] transition-transform',
                TEINTES[teinte],
            ].join(' ')}
        >
            <Icone className="h-10 w-10 shrink-0" aria-hidden="true" />
            {libelle}
        </button>
    );
}
